export const SET_ACTIVITIES = 'SET_ACTIVITIES';
export const SET_ACTIVITIES_LENGTH = 'SET_ACTIVITIES_LENGTH';
export const SET_ACTIVITIES_PER_PAGE = 'SET_ACTIVITIES_PER_PAGE';
export const SET_ACTIVITIES_CURRENT_PAGE = 'SET_ACTIVITIES_CURRENT_PAGE';
export const SET_ACTIVITIES_FILTERS = 'SET_ACTIVITIES_FILTERS';
